import { api } from "../../services/api";

export async function fetchTermosdeuso() {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem("@medusapayments:access_token");

    api
      .get(
        "/terms",

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}
